import { Icon } from 'components/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const EmptyConfigMarketSelector: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="border-grey-300 text-grey-600 border p-6 text-center">
      <div>
        <Icon name="EmptyMarket" />
      </div>
      <div className="my-3">
        {t('features:insights:customer-portal-insights:emptyMarket')}
      </div>
    </div>
  );
};
